const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/cursos",
    exact: true,
    component: "Cursos",
  },
  {
    path: "/pago-confirmado",
    exact: true,
    component: "PagoConfirmado",
  },
  {
    path: "/ticket",
    exact: true,
    component: "Ticket",
  },
  {
    path: "/cookies",
    exact: true,
    component: "Cookies",
  },
  {
    path: "/caja-signa",
    exact: false,
    component: "Admin",
  },
];

export default routes;
